import {
	SecurityCatchUpRightsFormDto,
	SecurityCatchUpRightsShape,
} from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Securities/SecurityDetails/SecurityFeatures/CatchUpRights/catchUpRights.zod.ts';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import {
	DataSecurityWithAllFeaturesAndRanksTct,
	SecurityCatchUpRightsBasis,
} from '@dealstack/shared/lib/generated';
import { zodResolver } from '@hookform/resolvers/zod';
import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

export enum CATCH_UP_RIGHTS_FORM_FIELD {
	target = 'target',
	basis = 'basis',
	rank = 'rank',
}

export const useCatchUpRightsController = (
	security: DataSecurityWithAllFeaturesAndRanksTct | null
) => {
	const tCapManage = useTranslationCapManage();

	const defaultValues = useMemo(
		() => ({
			target: security?.securityCatchUpRights?.target,
			basis:
				security?.securityCatchUpRights?.basis ??
				SecurityCatchUpRightsBasis.DISTRIBUTIONS_TO_SECURITIES_IN_HIGHER_OR_EQUAL_RANK,
		}),
		[security]
	);

	const catchUpRightsForm = useForm<SecurityCatchUpRightsFormDto>({
		mode: 'all',
		resolver: zodResolver(SecurityCatchUpRightsShape(tCapManage)),
		defaultValues,
		shouldFocusError: false,
	});

	const resetForm = () => {
		catchUpRightsForm.reset(defaultValues);
	};

	return {
		catchUpRightsForm,
		resetForm,
	};
};
export const makeCatchUpRightsOptions = (tCommonUi: TranslateFunction<I18Namespaces.COMMON_UI>) =>
	Object.values(SecurityCatchUpRightsBasis).map((basis) => ({
		label: getCatchUpRightsBasisLabel(tCommonUi, basis) ?? '',
		value: basis,
	}));

export const getCatchUpRightsBasisLabel = (
	tCommonUI: TranslateFunction<I18Namespaces.COMMON_UI>,
	basis?: SecurityCatchUpRightsBasis
) => {
	if (!basis) {
		return;
	}

	switch (basis) {
		case SecurityCatchUpRightsBasis.DISTRIBUTIONS_TO_SECURITIES_IN_HIGHER_OR_EQUAL_RANK:
			return tCommonUI(
				'security_catch_up_rights_basis.distributions_to_securities_in_higher_or_equal_rank'
			);
		case SecurityCatchUpRightsBasis.DISTRIBUTIONS_TO_SECURITIES_IN_HIGHER_RANK:
			return tCommonUI(
				'security_catch_up_rights_basis.distributions_to_securities_in_higher_rank'
			);
		default:
			return basis;
	}
};
